import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { AsyncPaginate } from 'react-select-async-paginate'
import KapalService from '../../../../services/kapal/KapalService'
import UserService from '../../../../services/user/UserService'
import PbUmkuService from '../../../../services/pbumku/PbumkuService'
import { getCurrentDateFormatted, romanNum } from '../../../../utilities/Utils'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalSt = ({ showSt, handleCloseSt, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [showConfirmPenugasan, setShowConfirmPenugasan] = useState(false)
    const handleCloseConfirmPenugasan = () => setShowConfirmPenugasan(false)
    const [showPenugasanSuccess, setShowPenugasanSuccess] = useState(false)
    const [showPenugasanFailed, setShowPenugasanFailed] = useState(false)
    const [rowPenugasan, setRowPenugasan] = useState(null)

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)
    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)

    let kapalService = useMemo(() => new KapalService(), [])
    let userService = useMemo(() => new UserService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            try {
                const resPejabat = await userService.getPegawaiById(dataDisposisi.nipPejabat)
                setValuePejabatOpt(resPejabat.data)

                const resPenugasanDtl = await kapalService.listPenugasanDetilAll(dataDisposisi.idProses)

                const optPetugas = resPenugasanDtl.data.map(item => ({
                    nip: item.nipPetugas,
                    nama: item.nmPetugas
                }))
                setValuePegawaiOpt(optPetugas)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, userService, dataPpmKapal, dataDisposisi])

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const onChangePegawaiOpt = e => {
        setValuePegawaiOpt(e)
    }

    const SavePenugasan = (dataDisposisi) => {
        setShowConfirmPenugasan(true)
        setRowPenugasan(dataDisposisi)
    }

    const handleClickPenugasan = async () => {
        setLoadingSave(true)
        try {
            let kodeStatus = ''
            let noSuratTugas = ''
            let jnsPenomoran = ''

            kodeStatus = '022'
            jnsPenomoran = 'ST_KAPAL'

            const respNomor = await pbumkuService.ambilNomorService(jnsPenomoran, dataPpmKapal.kodeUpt, currentYear, localStorage.getItem('username'))
            noSuratTugas = respNomor.data.uraianPusat + '/' + dataPpmKapal.kodeUpt + '/' + romanNum(currentMonth) + '/' + currentYear + '/' + respNomor.data.nomorUrut
            let jsonSpp = { ...rowPenugasan, noTugas: noSuratTugas, tglTugas: getCurrentDateFormatted(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resSpp = await kapalService.savePenugasan(jsonSpp)
            if (_resSpp.data.kode === '200') {
                valuePegawaiOpt.map(async (pegawai) => {
                    let jsonSppTugas = {
                        idProses: _resSpp.data.id,
                        nipPetugas: pegawai.nip,
                        nmPetugas: pegawai.nama
                    }
                    // console.log(jsonSppTugas)
                    await kapalService.savePenugasanDetil(jsonSppTugas)
                })


                let dataPpm = { ...dataPpmKapal, kodeStatus: kodeStatus }
                await kapalService.saveKapalHeader(dataPpm)

                let dataStatus = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    kodeStatus: kodeStatus,
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await kapalService.saveKapalStatus(JSON.stringify(dataStatus))

                setShowPenugasanSuccess(true)
                setShowConfirmPenugasan(false)
            }
        } catch (error) {
            console.log(error)
            setShowPenugasanFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickPenugasanSuccess = () => {
        setShowPenugasanSuccess(false)
        // window.location.reload()
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickPenugasanFailed = () => {
        setShowPenugasanFailed(false)
    }

    return (
        <>
            <Modal
                show={showSt}
                onHide={handleCloseSt}
                size='lg'
                centered
            >
                <Modal.Header>
                    <Modal.Title><h5>Surat Tugas Inspeksi</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="3">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                                isDisabled={!isEdit}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Petugas</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPegawai}
                                value={valuePegawaiOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePegawaiOpt}
                                isMulti
                                isDisabled={!isEdit}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => SavePenugasan(dataDisposisi)}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseSt}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmPenugasan &&
                <SweetAlert
                    title="Proses Penugasan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickPenugasan}
                    onCancel={handleCloseConfirmPenugasan}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showPenugasanSuccess &&
                <SweetAlert
                    title="Penugasan Berhasil"
                    success
                    onConfirm={handleClickPenugasanSuccess}
                    btnSize="sm"
                />
            }
            {
                showPenugasanFailed &&
                <SweetAlert
                    title="Penugasan Gagal"
                    danger
                    onConfirm={handleClickPenugasanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalSt